import React from 'react';
import { Actions } from '../../core/modules/Actions';
import { ModuleEvents } from './Actions';
import _ from "lodash";
import { navigateTo } from '../../core/services/NavigationServicd';
import { USER_ROLE, onToast } from '../../core/Constant';

export default {
  [ModuleEvents.LOGIN_USER]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
      const token = _.get(payload, 'data.token', null);
      const userId = _.get(payload, 'data.user.id', null);
      const userType = _.get(payload, 'data.user_type', null);
      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('userId', userId);
        localStorage.setItem('userType', USER_ROLE[userType]);

        const termsAccepted = _.get(payload, 'data.terms_accepted', false);
        localStorage.setItem('termsAccepted', termsAccepted ? 'true' : 'false');
        if (termsAccepted) {
          localStorage.setItem('termsAcceptedDate', new Date().toISOString());
        } else {
          localStorage.removeItem('termsAcceptedDate');
        }

        if (USER_ROLE.student == USER_ROLE[userType]) {
          onStudentnLoading({ dispatch, payload, appState })
        } else {
          onAddminLoading({ dispatch, payload, appState });
        }
      }
    } else {
      let value= payload;
      let title = 'Login Error'
      if(!payload){
        title='Network Error'
        value = {
         message: 'Please check your internet connection',
        status_code:0
        }
      }
      onToast(title, value);
    }
  },

  [ModuleEvents.LOGOUT_USER]: ({ dispatch, payload, appState }) => {
    const deviceId = localStorage.getItem('DeviceId')
    localStorage.clear()
    localStorage.setItem('DeviceId',deviceId)
    onToast('Logout', payload);
  },

  [ModuleEvents.FORGOT_PASSWORD_STEP_ONE]: ({ dispatch, payload, appState }) => {
    onToast('Forgot Password', payload, false);
  },

  [ModuleEvents.FORGOT_PASSWORD_STEP_TWO]: ({ dispatch, payload, appState }) => {
    onToast('Forgot Password', payload, false);
  },

  [ModuleEvents.FORGOT_PASSWORD_STEP_THREE]: ({ dispatch, payload, appState }) => {
    onToast('Reset Password', payload, false);
  },

  [ModuleEvents.SIGN_UP]: async ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
      const data = _.get(payload, 'params', {})
      dispatch(Actions.auth.logIn({ ...data }));
      dispatch(Actions.auth.cleanVerifiedEmailData())
    }
    onToast('Sign up', payload, false)
  },

  

  [ModuleEvents.VERIFY_TOKEN]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error && payload.status_code && payload.status_code == 1) {
      const userType = _.get(payload, 'data.user_type', null);
      localStorage.setItem('userType', USER_ROLE[userType]);
      const path = window.location.pathname;
      if (path == '/' || path == '/*') {
        if (USER_ROLE.student == USER_ROLE[userType]) {
          onStudentnLoading({ dispatch, payload, appState })
        } else {
          onAddminLoading({ dispatch, payload, appState });
        }
      }
      //else{
      //   navigateTo(path)
      // }


    } else {
      // Check if error is 403 (Forbidden) - likely due to terms not accepted
      // Don't redirect if it's a 403 error - let the terms dialog handle it
      const httpStatus = payload?.status || null;
      const errorMessage = _.get(payload, 'data.message', '') || _.get(payload, 'message', '');
      const isTermsError = errorMessage && (
        errorMessage.toLowerCase().includes('terms') || 
        errorMessage.toLowerCase().includes('condition')
      );
      const is403Error = httpStatus === 403 || httpStatus === '403' || isTermsError;
      
      const path = window.location.pathname;
      const hasToken = localStorage.getItem('token');
      
      // Only redirect if:
      // 1. No token exists (user not logged in) OR
      // 2. Error is not 403/terms-related
      // If 403/terms error and has token, don't redirect - stay on current route
      if (!hasToken) {
        // No token means not logged in, redirect to login
        if (path != '/' && path != '/welcome' && path != '/login') {
          navigateTo('/');
        }
        localStorage.removeItem('token');
      } else if (!is403Error) {
        // Has token but error is not 403/terms-related - might be expired token
        if (path != '/' && path != '/welcome' && path != '/login') {
          navigateTo('/');
        }
        localStorage.removeItem('token');
      }
      // If 403/terms error and has token, don't redirect - let terms dialog handle it
    }

  },
};


const onAddminLoading = ({ dispatch, payload, appState }) => {
  navigateTo('/admin-dashboard');
  dispatch(Actions.home.getAdminDashboardData());
  dispatch(Actions.profile.getUserData());
}


const onStudentnLoading = ({ dispatch, payload, appState }) => {
  navigateTo('/dashboard');
  const termsAccepted = _.get(payload, 'data.terms_accepted', false);
  if (termsAccepted) {
    dispatch(Actions.profile.getUserData());
  }
}